import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as structures from '../../../../../structures'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Financial Contact',
    partialId: PartialId.Standard.create('fin_contact'),
    type: {
      structureId: core.dms.models.Structure.Id.from(
        structures.contact.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
